import {Customer} from '@/models/Customer'
import {Model} from '@/models/Model'
import {Order} from '@/models/Order'
import {DataArray, DataResource} from '@/models/Response'
import {User} from '@/models/User'
import Helper from '../services/Helper.js'


export const OrderUserConst = Object.freeze({

    COM_OPTION_NORMAL: 0,
    COM_OPTION_SHIFT_NEXT_REQUEST: 2,
    COM_OPTION_SHIFT_NEXT: 10,
    COM_OPTION_SKIP_REQUEST: 3,
    COM_OPTION_SKIP: 99,
    COM_OPTION_TIER2: 50,


    map(status: number): string {
        switch (parseInt(`${status}`)) {
            case OrderUserConst.COM_OPTION_NORMAL:
                return 'ปกติ'
            case OrderUserConst.COM_OPTION_SHIFT_NEXT_REQUEST:
                return 'ขอโอน'
            case OrderUserConst.COM_OPTION_SHIFT_NEXT:
                return 'โอนแล้ว'
            case OrderUserConst.COM_OPTION_SKIP_REQUEST:
                return 'ขอข้าม'
            case OrderUserConst.COM_OPTION_SKIP:
                return 'ข้าม'
            case OrderUserConst.COM_OPTION_TIER2:
                return 'Tier2'
        }
        // debugger
        return ''
    },

    color(status: number | null | undefined): string {
        switch (parseInt(`${status}`)) {
            case OrderUserConst.COM_OPTION_NORMAL:
                return 'grey'
            case OrderUserConst.COM_OPTION_SHIFT_NEXT_REQUEST:
                return 'red'
            case OrderUserConst.COM_OPTION_SHIFT_NEXT:
                return 'green'
            case OrderUserConst.COM_OPTION_SKIP_REQUEST:
                return 'grey darken-2'
            case OrderUserConst.COM_OPTION_SKIP:
                return 'grey darken-4'
            case OrderUserConst.COM_OPTION_TIER2:
                return 'grey darken-3'
        }
        // debugger
        return ''
    }

})

export class OrderUser extends Model {

    declare id: number
    created_at: Date | null
    updated_at: Date | null
    order_id: number
    order: Order | null
    user_code: string | null
    user: User | null
    customer: Customer | null
    com_option: number | null

    slip_id: number | null
    slip_paid_internal: number | null
    slip_paid_external: number | null

    getResourceURL(): string {
        return Helper.setting.order_user.getResourceAPI
    }


}

export class DataOrderUser extends DataResource {

    declare data: OrderUser

}


export class DataOrderUsersArray extends DataArray {

    declare data: OrderUser[]
    // filter: FilterOrder = new FilterOrder()
}

//
//
// export class FilterOrder {
//
//   status: FilterSet = new FilterSet()
// }
